module.exports = __webpack_public_path__ + "static/media/TRIAL 2.0f02aa2b.mp3";